import React from "react"
import PropTypes from "prop-types"

import IncentivizedUploadHeading from "./IncentivizedUploadHeading"

import { getIncentivizedUploadData } from "frontend/utils/upload"

import styles from "./IncentivizedUploadBanner.module.css"

export default function IncentivizedUploadBanner({ showLead }) {
  const { thumbnail, title } = getIncentivizedUploadData()

  return (
    <section className={styles.container} data-testid="incentivized-upload-banner">
      <div className={styles.content}>
        <img alt={title} className={styles.image} src={thumbnail} />
        {showLead ? (
          <h5 className={styles.lead}>
            <IncentivizedUploadHeading />
          </h5>
        ) : null}
      </div>
    </section>
  )
}

IncentivizedUploadBanner.propTypes = {
  showLead: PropTypes.bool,
}

IncentivizedUploadBanner.defaultProps = {
  showLead: false,
}
